import * as cx from 'classnames';
import { AUTHOR, TOPIC_COUNSELLOR, TOPIC_MODERATOR } from 'mk/autogenerated/translations/CommentHeaderName.43e5e6d7cc6b8f1cbf3c333aa94743e0'
import { getInlinedImages, linebreaksbr, mentionize, replaceImageMarks, urlize } from 'mk/bazaar/common/filters';
import { authorIsModerator } from 'mk/bazaar/common/userUtils';
import { user_profile_url } from 'mk/urls/functions';
import { CommentEntity } from 'mk2/apps/blogs/schemas';
import { CounsellingEntity } from 'mk2/apps/forum/schemas';
import * as urls from 'mk2/apps/forum/urls';
import Link from 'mk2/components/Link';
import { url } from 'mk2/helpers/urls';
import { UserEntity } from 'mk2/schemas';
import * as React from 'react';
import styles from './CommentHeaderName.mscss';

interface OwnProps {
    comment: CommentEntity;
    inForum: boolean;
    inGroups: boolean;
    moderators: UserEntity[];
    counselling: CounsellingEntity;
    topicSlug: string;
}

type Props = OwnProps;

class CommentHeaderName extends React.PureComponent<Props> {

    public render() {
        const { comment, counselling, inForum, inGroups, moderators, topicSlug } = this.props;

        const isPostAuthor = comment.authorUser.username === comment.targetOwner.username;
        const authorIsTopicModerator = (inForum || inGroups) && authorIsModerator(comment.authorUser, moderators);
        const counsellingTopicSlug = counselling && topicSlug ? url(urls.forumTopic, {topicSlug}) : null;

        return [
            // don't show author data for counselling, show counselling specific data
            counselling ? (
                <Link key="author" to={counsellingTopicSlug}>
                    <div className={styles.CommentHeaderName__counsellorInfo}>
                        <div className={styles.CommentHeaderName__counsellorName}>
                            {counselling.counsellorName}
                        </div>
                        <div className={styles.CommentHeaderName__counsellorBadge}>
                            {TOPIC_COUNSELLOR}
                        </div>
                    </div>
                </Link>
            ) : (
                <a
                    key="author"
                    className={cx(
                        styles.CommentHeaderName__author,
                        !inGroups && styles['CommentHeaderName__author--inForum'],
                        inGroups && styles['CommentHeaderName__author--inGroups'],
                    )}
                    href={user_profile_url(comment.authorUser.username)}
                >
                    {comment.authorUser.username}
                </a>
            ),

            isPostAuthor && (
                <span key="badgeAuthor" className={cx(styles.CommentHeaderName__badge, styles.CommentHeaderName__badgeAuthor)}>
                    {AUTHOR}
                </span>
            ),

            authorIsTopicModerator && (
                <span key="badgeModerator" className={cx(styles.CommentHeaderName__badge, styles.CommentHeaderName__badgeModerator)}>
                    {TOPIC_MODERATOR}
                </span>
            ),
        ];
    }
}

export default CommentHeaderName;
